// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__przL2","skeleton-animation":"styles_skeleton-animation__8cLjG"};